import React from 'react'
import './Backdrop.css'

const Backdrop = (props) => {
    return(
        <div className="custom-backdrop" onClick={props.close} />
    )
}

export default Backdrop;